module.exports = __webpack_public_path__ + "img/play-circle.74b5c0a5.svg";